import { Box, Flex, HStack, Image, Text } from "@chakra-ui/react";
import { digit } from "lib/utils/digit";
import CheckBox from "components/CheckBox";
import { ItemModel } from "lib/api/model";
import { OrderStatus } from "lib/api/enum";
import { convertDateYYYYMMDDSymbol } from "lib/utils/regular";

interface IProductItemProps {
    item: ItemModel;
    checkedIdList: number[];
    onCheckPressed: (itemId: number, isChecked: boolean) => void;
    onDeletePressed: (itemId: number) => void;
    gotoDetail: (itemId: number) => void;
}

function ProductItem(props: IProductItemProps) {
    const onCheckHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.onCheckPressed(props.item.item_id, event.target.checked);
    };

    return (
        <Flex
            px="20px"
            flexDirection={"column"}
            alignItems="flex-start"
            position={"relative"}
        >
            <Box h={"17px"} w="full" />
            <Flex
                w={"full"}
                h={"full"}
                alignItems="flex-start"
                flex={1}
                gap={"12px"}
            >
                <Flex alignItems={"flex-start"} h="full">
                    <CheckBox
                        size={20}
                        isChecked={
                            props.checkedIdList.find(
                                (id) => id === props.item.item_id
                            ) !== undefined
                        }
                        isDisabled={
                            props.item.item_status === OrderStatus.REQUESTING
                        }
                        onChange={onCheckHandler}
                    />
                </Flex>
                <HStack
                    flex={1}
                    spacing={"8px"}
                    alignItems="flex-start"
                    onClick={() => props.gotoDetail(props.item.item_id)}
                >
                    <Image
                        boxSize={"64px"}
                        src={props.item.image.before[0]}
                        border={"1px"}
                        borderColor="#eeeeee"
                        borderRadius={"4px"}
                    />
                    <Box flex="1">
                        <Text
                            fontSize={"16px"}
                            fontWeight="semibold"
                            width={{ base: "195px", sm: "400px" }}
                            lineHeight="1.33rem"
                        >
                            {`${props.item.category_name} / ${props.item.material_name}`}
                        </Text>
                        <Text
                            fontSize={"13px"}
                            fontWeight="medium"
                            textColor={"#757575"}
                            mt="0.375rem"
                            mb={"0.625rem"}
                        >
                            {props.item.service_name.join("·")}
                        </Text>
                        <HStack justifyContent={"space-between"}>
                            {props.item.item_status ===
                            OrderStatus.REQUESTING ? (
                                <Text
                                    fontSize={"15px"}
                                    fontWeight="bold"
                                    textColor={"#fda02d"}
                                >
                                    {"견적 진행 중"}
                                </Text>
                            ) : (
                                <Text fontSize={"15px"} fontWeight="bold">
                                    {digit(props.item.item_price) + " 원"}
                                </Text>
                            )}

                            <Text
                                fontSize={"13px"}
                                fontWeight="medium"
                                textColor={"#757575"}
                            >
                                {convertDateYYYYMMDDSymbol(
                                    props.item.reg_date
                                ) + " 저장됨"}
                            </Text>
                        </HStack>
                    </Box>
                </HStack>
            </Flex>
            <Image
                position={"absolute"}
                top={"17px"}
                right={"20px"}
                src="/assets/images/icn_trash.svg"
                onClick={() => props.onDeletePressed(props.item.item_id)}
            />
            <Box
                h={"17px"}
                w="full"
                borderBottom={"1px"}
                borderBottomColor="#eeeeee"
            />
        </Flex>
    );
}
export default ProductItem;
